module.exports = __webpack_public_path__ + "static/media/settings-cartmate-logo.622d717c.svg";